// Shared IST date helpers for Q-Pay Centre pages.
// Input: ISO string / Date / epoch ms (a real UTC instant). Output is always IST (UTC+5:30),
// independent of the browser timezone. Invalid/empty -> '-'.
const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;
const pad = (n) => String(n).padStart(2, '0');

const toIstParts = (d) => {
  if (d === null || d === undefined || d === '') return null;
  const date = d instanceof Date ? d : new Date(d);
  if (isNaN(date.getTime())) return null;
  const x = new Date(date.getTime() + IST_OFFSET_MS); // read with UTC getters = IST wall clock
  return {
    dd: pad(x.getUTCDate()),
    mm: pad(x.getUTCMonth() + 1),
    yyyy: x.getUTCFullYear(),
    h: x.getUTCHours(),
    mi: pad(x.getUTCMinutes()),
    ss: pad(x.getUTCSeconds())
  };
};

// 'DD/MM/YYYY'. A plain 'YYYY-MM-DD' string (date picker value) is formatted as-is, no tz shift.
export const formatDateIST = (d) => {
  if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d.trim())) {
    const [y, m, day] = d.trim().split('-');
    return `${day}/${m}/${y}`;
  }
  const p = toIstParts(d);
  return p ? `${p.dd}/${p.mm}/${p.yyyy}` : '-';
};

// 'DD/MM/YYYY, hh:mm:ss A' (12-hour, uppercase AM/PM)
export const formatDateTimeIST = (d) => {
  const p = toIstParts(d);
  if (!p) return '-';
  const ampm = p.h >= 12 ? 'PM' : 'AM';
  const h12 = p.h % 12 === 0 ? 12 : p.h % 12;
  return `${p.dd}/${p.mm}/${p.yyyy}, ${pad(h12)}:${p.mi}:${p.ss} ${ampm}`;
};
